import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as actions from "../actions/actionTypes";
var ActionRegistry = /*#__PURE__*/function () {
  function ActionRegistry() {
    _classCallCheck(this, ActionRegistry);
    this.actions = {};
  }
  _createClass(ActionRegistry, [{
    key: "addActions",
    value: function addActions(actionObject) {
      this.actions = _objectSpread(_objectSpread({}, this.actions), actionObject);
    }
  }, {
    key: "removeActions",
    value: function removeActions() {
      var _this = this;
      for (var _len = arguments.length, actionKeys = new Array(_len), _key = 0; _key < _len; _key++) {
        actionKeys[_key] = arguments[_key];
      }
      actionKeys.forEach(function (actionKey) {
        _this.actions[actionKey] = null;
      });
    }
  }, {
    key: "getActions",
    value: function getActions() {
      return this.actions;
    }
  }]);
  return ActionRegistry;
}();
var actionRegistry = new ActionRegistry();
actionRegistry.addActions(actions);
export default actionRegistry;